
























































































import ReferencesBauminator from "@/components/ReferencesBauminator.vue";
import {Component, Vue, Watch} from 'vue-property-decorator';
import '@/less/style.less'
import HotspotBauminator from "@/components/HotspotBauminator.vue";
import welcomeBuminator from "@/components/welcomeBuminator.vue";
import visionForTheWallBauminator from "@/components/visionForTheWallBauminator.vue";
import contactBuminator from "@/components/contactBuminator.vue";
import concreteBuminatorMobile from "@/components/concreteBuminatorMobile.vue";
import concreteBuminator from "@/components/concreteBuminator.vue";
import SamplesBauminator from "@/components/SamplesBauminator.vue";
import videoBuminator from "@/components/videoBuminator.vue";
import MergeBauminator from "@/components/MergeBauminator.vue";
import visionForTheWallBauminatorMobile from "@/components/visionForTheWallBauminatorMobile.vue";
import SamplesBauminatorMobile from "@/components/SamplesBauminatorMobile.vue";
import getBrochureBuminator from "@/components/getBrochureBuminator.vue";
import SwipeBauminatorBLock from "@/components/SwipeBauminatorBLock.vue";
import partnersMap from "@/components/partners-map/partners-map.vue";
import {translate} from "@/services/trans";
import ReferencesBauminatorMobile from "@/components/ReferencesBauminatorMobile.vue";

declare let bauminatorData: any;

@Component({
  components: {
    ReferencesBauminatorMobile,
    ReferencesBauminator,
    contactBuminator,
    visionForTheWallBauminator,
    concreteBuminator,
    concreteBuminatorMobile,
    SamplesBauminator,
    videoBuminator,
    welcomeBuminator,
    MergeBauminator,
    visionForTheWallBauminatorMobile,
    SamplesBauminatorMobile,
    getBrochureBuminator,
    SwipeBauminatorBLock,
    HotspotBauminator,
    partnersMap
  },
})
export default class App extends Vue {
  public isMobileView = true
  public showPartnersMap = false;
  public welcomeContactTarget: string = 'contact';
  public visibleElement: Array<any> = [];
  public references: Array<any> = [];

  mounted() {
    window.addEventListener('resize', this.onResize)
    if (bauminatorData && bauminatorData.mapData && bauminatorData.mapData.partnerTypes) {
      this.showPartnersMap = true;
      this.welcomeContactTarget = 'partners-map'
    }
    if (bauminatorData && bauminatorData.references) {
      this.references = bauminatorData.references;
    }
    this.addVisibleElements()
    this.setIsMobileView()

  }

  addVisibleElements() {

    this.visibleElement = [
      {name: 'welcomeBuminator'},
      {name: 'MergeBauminator'},
      {name: 'vision'},
      {name: 'samples'},
      {name: 'optimize'},
      {name: 'bauminatorHotspotContainer'},
      {name: 'brochure'},
      {name: 'optimize2'},
      {name: 'videoBuminator'},
      {name: 'exterior'},
      {name: 'industrie'},
    ]
    if (this.showPartnersMap) {
      this.visibleElement.push({name: 'partners-map'});
    }
    if (this.references.length > 0) {
      this.visibleElement.push({name: 'references'});
    }
    this.visibleElement.push({name: 'contact'});
  }

  onResize() {
    this.setIsMobileView()
  }

  setIsMobileView() {
    if (window.visualViewport.width < 960) {
      this.isMobileView = true
    } else {
      this.isMobileView = false
    }
  }

  trans(key: string) {
    return translate(key)
  }


  @Watch("next", {immediate: true, deep: true})
  nextFrom(name: string, isDown: boolean = false) {
    console.log('nextfrom', name, isDown);
    this.visibleElement.map((element, index) => {
      if (element.name.indexOf(name) == 0 && element.name == name && this.isEnabledNext && !isDown) {
        this.isEnabledNext = false;
        (window as any).$("html, body").animate(
            {
              scrollTop: (window as any).$("#" + this.visibleElement[index + 1].name).offset().top
            },
            500,
            "linear"
        );
        setTimeout(() => {
          this.isEnabledNext = true
        }, 600)
      }
    })
  }

  isEnabledNext = true


  @Watch("scroll", {immediate: true, deep: true})
  scrollToOn(name: string, isDown: boolean = false) {
    console.log('scrollToOn', name, isDown)
    if (typeof name != 'undefined' && this.isEnabledNext) {
      console.log('scroll, name', name)
      this.isEnabledNext = false;
      (window as any).$("html, body").animate(
          {
            scrollTop: (window as any).$("#" + name).offset().top
          },
          500,
          "linear"
      );
      setTimeout(() => {
        this.isEnabledNext = true
      }, 600)
    }
  }
}
